export {default} from './ProfileContactSectionWithCheckbox.connect';
